var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Message_icon_-_bigger",
    "data-name": "Message icon - bigger",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23.994,
    viewBox: "0 0 22 23.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_5",
    "data-name": "Union 5",
    d: "M18.528,23.788l-2.857-1.64q-.146-.083-.307-.17l-.1-.053c-.128-.069-.258-.14-.382-.213A10.774,10.774,0,0,1,11,22.43c-.354,0-.708-.016-1.056-.05a10.869,10.869,0,0,1-6.623-3.145,11.243,11.243,0,0,1-3.24-6.675,11.446,11.446,0,0,1,.459-4.81,11.174,11.174,0,0,1,2.247-3.99,10.856,10.856,0,0,1,15.995-.474,11.383,11.383,0,0,1,.915,14.806c.039.137.075.278.116.431.013.047.025.094.037.141s.023.087.035.13l.871,3.231a1.57,1.57,0,0,1-.254,1.35,1.538,1.538,0,0,1-1.216.619A1.5,1.5,0,0,1,18.528,23.788Zm-2.982-3.451c.133.081.3.172.461.258l.011.006c.118.064.256.139.388.215l2.858,1.64.018.009a.056.056,0,0,0,.023-.02.007.007,0,0,0,0,0s0,0,0-.014l-.87-3.227c-.019-.071-.038-.145-.057-.22l-.018-.065c-.044-.172-.091-.351-.138-.5l-.2-.64.411-.523a9.748,9.748,0,0,0,1.518-2.78,9.911,9.911,0,0,0,.458-4.6,9.534,9.534,0,0,0-1.675-4.289A9.436,9.436,0,0,0,11,1.528,9.749,9.749,0,0,0,9.8,1.6,9.179,9.179,0,0,0,5.434,3.357,9.8,9.8,0,0,0,2.162,7.644a10.057,10.057,0,0,0-.494,5.43A9.377,9.377,0,0,0,3.043,16.53,9.862,9.862,0,0,0,6.52,19.763a9.386,9.386,0,0,0,7.939.479l.566-.226Z",
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2074",
    "data-name": "Path 2074",
    d: "M9.545,16A1.76,1.76,0,1,1,7.82,17.76,1.743,1.743,0,0,1,9.545,16",
    transform: "translate(-3.061 -6.348)",
    fill: "#333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2075",
    "data-name": "Path 2075",
    d: "M17.4,16a1.76,1.76,0,1,1-1.725,1.76A1.743,1.743,0,0,1,17.4,16",
    transform: "translate(-6.397 -6.348)",
    fill: "#333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2076",
    "data-name": "Path 2076",
    d: "M25.249,16a1.76,1.76,0,1,1-1.725,1.76A1.743,1.743,0,0,1,25.249,16",
    transform: "translate(-9.733 -6.348)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageImage);
export default __webpack_public_path__ + "static/media/messageImage.c722dc9389d6dec5c9532b8623d2d76a.svg";
export { ForwardRef as ReactComponent };